"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Subtitle = function Subtitle(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: Object.assign((0, _Fonts.withWidgetSubtitleFont)({
      paddingLeft: '5%',
      paddingRight: '5%',
      color: _Colors.discreetTextColor,
      marginTop: 5,
      marginBottom: 5
    }), style)
  }, children);
};

var _default = Subtitle;
exports["default"] = _default;